export class CoverageRate {
	tier: string;
	employeeDeduction: string;
	deductionFrequency: string;
	showDeductionInfo: boolean;

	constructor() {
		this.tier = '';
		this.employeeDeduction = '';
		this.deductionFrequency = '';
		this.showDeductionInfo = false;
	}
}

export class CoverageRatePayload {
	selectedDependentIds: number[];
	coverageDetailID: number;

	constructor() {
		this.selectedDependentIds = [];
		this.coverageDetailID = 0;
	}
}